import { makeStyles } from "@material-ui/core/styles";

const ConfirmationDialogJSS = makeStyles((theme) => ({
  warning: {
    backgroundColor: theme.palette.warning.main,
    color: theme.palette.warning.contrastText,
  },
  error: {
    backgroundColor: theme.palette.error.main,
    color: theme.palette.error.contrastText,
  },
  success: {
    backgroundColor: theme.palette.success.main,
    color: theme.palette.success.contrastText,
  },
  info: {
    backgroundColor: theme.palette.info.main,
    color: theme.palette.info.contrastText,
  },
  default: {
    backgroundColor: theme.palette.white.light,
    color: theme.palette.white.contrastText,
  },
  primary: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
  },
  dialogTitle: {
    textAlign: "center",
    color: '#464646',
    fontSize: '1.25rem'
  },
  button: {
    margin: "auto",
    marginBottom: theme.spacing(6)
  },
  additionalInfo: {
    textAlign: "center",
    marginTop: `${theme.spacing(12)}px`,
    marginBottom: theme.spacing(12),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
  },
  divider: {
    width: '100%'
  }
}));
export default ConfirmationDialogJSS;
